import { initBotId } from "botid/client/core";

initBotId({
  protect: [
    { path: "/api/demo-request", method: "POST" },
    { path: "/api/newsletter-subscribe", method: "POST" },
    { path: "/api/calculator-submission", method: "POST" },
    { path: "/api/data-deletion", method: "POST" },
    // Ask FlexTrap funnel. Every route that calls checkBotId() server-side
    // MUST be listed here: unregistered routes carry no BotID signals, so
    // deployed environments classify every real visitor as a bot (403).
    { path: "/api/ask-session", method: "POST" },
    { path: "/api/ask", method: "POST" },
  ],
});
